"use strict";

import {addClass, removeClass, on, closest, findIn, setAttribute, removeAttribute} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.js-file-input', function (fileInput) {
        let input = findIn('.js-file-input__input', fileInput);
        let label = findIn('.js-file-input__label', fileInput);

        on('change', function () {
            if (input.files.length === 0) {
                addClass('is-empty', label);
            } else {
                removeClass('is-empty', label);
            }
        }, input);
    });
}